import React from "react";
import Dashboard from "../Dashboard/Dashboard";
import ChangeMasterUserProfile from "../../Sections/Auth/ChangeProfile_index";

const DashboardComponent = () => {
    return (
        <Dashboard sectionName={<ChangeMasterUserProfile />}/>
    );
};

export default DashboardComponent;
